// Airline logo URLs from public CDN
// Using airline IATA codes as keys - Duffel CDN for better compatibility
export const airlineLogos = {
  // Major European Airlines
  'BA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BA.svg', // British Airways
  'AF': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AF.svg', // Air France
  'KL': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KL.svg', // KLM
  'LH': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LH.svg', // Lufthansa
  'IB': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/IB.svg', // Iberia
  'AZ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AZ.svg', // Alitalia/ITA
  'SK': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SK.svg', // SAS
  'AY': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AY.svg', // Finnair
  'TP': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TP.svg', // TAP Portugal
  'SN': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SN.svg', // Brussels Airlines
  'LX': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LX.svg', // Swiss
  'OS': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OS.svg', // Austrian
  'EI': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EI.svg', // Aer Lingus
  'VS': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VS.svg', // Virgin Atlantic
  
  // Low Cost European
  'U2': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/U2.svg', // EasyJet
  'FR': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FR.svg', // Ryanair
  'W6': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/W6.svg', // Wizz Air
  'VY': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VY.svg', // Vueling
  'LS': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LS.svg', // Jet2
  'BY': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BY.svg', // TUI Airways
  'NO': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NO.svg', // Neos
  'TO': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TO.svg', // Transavia
  'PC': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PC.svg', // Pegasus
  
  // US Airlines
  'AA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg', // American Airlines
  'UA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UA.svg', // United
  'DL': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DL.svg', // Delta
  'B6': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B6.svg', // JetBlue
  'WN': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/WN.svg', // Southwest
  'AS': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AS.svg', // Alaska Airlines
  'NK': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NK.svg', // Spirit
  'F9': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/F9.svg', // Frontier
  
  // Middle East & Gulf
  'EK': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EK.svg', // Emirates
  'QR': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg', // Qatar Airways
  'EY': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EY.svg', // Etihad
  'TK': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TK.svg', // Turkish Airlines
  'SV': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SV.svg', // Saudia
  'GF': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GF.svg', // Gulf Air
  'WY': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/WY.svg', // Oman Air
  'RJ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/RJ.svg', // Royal Jordanian
  'MS': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MS.svg', // Egyptair
  
  // Asian Airlines
  'SQ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SQ.svg', // Singapore Airlines
  'CX': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CX.svg', // Cathay Pacific
  'JL': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/JL.svg', // Japan Airlines
  'NH': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NH.svg', // ANA
  'KE': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KE.svg', // Korean Air
  'OZ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OZ.svg', // Asiana
  'TG': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TG.svg', // Thai Airways
  'MH': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MH.svg', // Malaysia Airlines
  'GA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GA.svg', // Garuda Indonesia
  'PR': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PR.svg', // Philippine Airlines
  'VN': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VN.svg', // Vietnam Airlines
  'AI': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AI.svg', // Air India
  'UK': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UK.svg', // Vistara
  '6E': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/6E.svg', // IndiGo
  'CA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CA.svg', // Air China
  'MU': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MU.svg', // China Eastern
  'CZ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CZ.svg', // China Southern
  'HU': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HU.svg', // Hainan Airlines
  'PK': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PK.svg', // Pakistan International Airlines (PIA)
  'PA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PA.svg', // Airblue (Pakistan)
  'UL': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UL.svg', // SriLankan Airlines
  'BG': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BG.svg', // Biman Bangladesh
  
  // Oceania
  'QF': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QF.svg', // Qantas
  'NZ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NZ.svg', // Air New Zealand
  'VA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VA.svg', // Virgin Australia
  
  // Africa
  'SA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SA.svg', // South African Airways
  'ET': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ET.svg', // Ethiopian Airlines
  'KQ': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KQ.svg', // Kenya Airways
  'AT': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AT.svg', // Royal Air Maroc
  
  // Canada
  'AC': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AC.svg', // Air Canada
  'WS': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/WS.svg', // WestJet
  
  // Latin America
  'LA': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LA.svg', // LATAM
  'AV': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AV.svg', // Avianca
  'CM': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CM.svg', // Copa Airlines
  'G3': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/G3.svg', // Gol
  'AM': 'https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AM.svg', // Aeromexico
};

// Get airline logo URL with fallback
export const getAirlineLogo = (airlineCode) => {
  if (!airlineCode) return null;
  const code = airlineCode.toUpperCase().trim();
  // Use Duffel as primary CDN, with fallback to Duffel URL pattern
  return airlineLogos[code] || `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${code}.svg`;
};

// Airline Logo Component - Shows airline logo image with fallback to airline code
// When `prominent` is true, renders a large Flightcatchers-style logo with fixed
// container dims (70x60 mobile / 90x70 desktop) and constrained image maxes so
// the actual airline artwork remains visibly large and recognisable.
export const AirlineLogo = ({ code, className = 'w-10 h-10', showBorder = false, prominent = false }) => {
  const logoUrl = getAirlineLogo(code);

  if (prominent) {
    const containerCls = 'flex items-center justify-center bg-white border border-[#E5E7EB] rounded-[10px] w-[70px] h-[60px] min-w-[70px] sm:w-[90px] sm:h-[70px] sm:min-w-[90px] overflow-hidden';
    const imgCls = 'w-auto h-auto max-w-[60px] max-h-[46px] sm:max-w-[78px] sm:max-h-[55px] object-contain';
    const fallbackCls = 'text-[22px] font-bold text-[#222222] leading-none';

    if (!logoUrl) {
      return (
        <div className={containerCls}>
          <span className={fallbackCls}>{code}</span>
        </div>
      );
    }
    return (
      <div className={containerCls}>
        <img
          src={logoUrl}
          alt={`${code} airline logo`}
          className={imgCls}
          loading="eager"
          referrerPolicy="no-referrer"
          onError={(e) => {
            e.target.style.display = 'none';
            if (e.target.parentElement) {
              e.target.parentElement.innerHTML = `<span class="${fallbackCls}">${code || ''}</span>`;
            }
          }}
        />
      </div>
    );
  }

  if (!logoUrl) {
    return (
      <div className={`${className} flex items-center justify-center bg-gray-100 rounded-lg`}>
        <span className="text-sm font-bold text-slate-600">{code}</span>
      </div>
    );
  }

  return (
    <div className={`${className} flex items-center justify-center ${showBorder ? 'bg-white rounded-lg border border-slate-200 p-1' : ''} overflow-hidden`}>
      <img 
        src={logoUrl} 
        alt={`${code} airline logo`}
        className="w-full h-full object-contain"
        loading="eager"
        referrerPolicy="no-referrer"
        onError={(e) => {
          // Replace with styled fallback on load error
          e.target.style.display = 'none';
          if (e.target.parentElement) {
            e.target.parentElement.innerHTML = `<span class="text-sm font-bold text-slate-600">${code || ''}</span>`;
          }
        }}
      />
    </div>
  );
};
